// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = require('./_to-iobject');
var $getOwnPropertyDescriptor = require('./_object-gopd').f;

require('./_object-sap')('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});



//////////////////
// WEBPACK FOOTER
// ./~/.store/core-js@2.6.12/~/core-js/modules/es6.object.get-own-property-descriptor.js
// module id = 777
// module chunks = 75